import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import API from '../endpoints';
import { getAccessToken } from '../utils/getAccessToken';
import { useGlobalContext } from '@slc/tools/GlobalContext';

// 10 minutes frontend cache for page layout query
const CACHE_TIME = 10 * 60 * 1000;

export const useCmsPageLayoutQuery = (slug: string | undefined) => {
  const { apiUrl } = useGlobalContext();

  return useQuery({
    queryKey: ['cms-page', { slug: slug! }, apiUrl],
    queryFn: () => fetchCmsPageLayout(apiUrl, slug!),
    enabled: !!slug && !!apiUrl,
    staleTime: !getAccessToken() ? CACHE_TIME : undefined,
  });
};

const fetchCmsPageLayout = async (apiUrl: string, slug: string): Promise<any> => {
  const accessToken = getAccessToken();
  const { data } = await axios.get<any>(`${apiUrl}${API.endpoints.pageLayout}`, {
    params: {
      slug,
    },
    headers: accessToken
      ? {
          Authorization: `Bearer ${accessToken}`,
        }
      : {},
  });
  return data;
};
